import { MyLensesSortDirection, type SortBy } from "../../../gql-generated/types";
import { type Pagination } from "../models";

const toggleSortDirection = (sortDirection: MyLensesSortDirection) => {
    return sortDirection === MyLensesSortDirection.SortDirectionAsc
        ? MyLensesSortDirection.SortDirectionDesc
        : MyLensesSortDirection.SortDirectionAsc;
};

export const updateSort = (pagination: Pagination, nextSortBy: SortBy): Pagination => {
    const { sortBy, sortDirection } = pagination;
    if (sortBy === nextSortBy) {
        return { ...pagination, sortDirection: toggleSortDirection(sortDirection), offset: 0 };
    }
    return {
        ...pagination,
        sortDirection: MyLensesSortDirection.SortDirectionDesc,
        sortBy: nextSortBy,
        offset: 0,
    };
};
